import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const DashboardContent = lazy(() => import('./DashboardContent'));



const Dashboard = () => {
    return (
        <Suspense fallback={<DefaultLoader />}>
            <DashboardContent />
        </Suspense>
    );
};

export default Dashboard;